/**
 * Created by caimingxun on 2016/12/7.
 */

import ReactGA from 'react-ga'

// 點擊個人頁 觀看紀錄、收藏 時回傳
export const gaMember = (memberAction, dramaName) => {
  ReactGA.event({
    category: '01. 會員功能',
    action: memberAction,
    label: dramaName,
  })
}

export const clickFavoriteBtn = (type, sourcePageName) => {
  ReactGA.event({
    category: '01. 會員功能',
    action: type,
    label: sourcePageName,
  })
}

export const getAccountId = (userAction) => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '查看會員編號',
    label: userAction,
  })
}

// 9.7.0 - 點擊帳號合併中『連結』按鈕時回傳
export const gaClickBind = () => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '帳號合併',
    label: '連結',
  })
}

// 9.7.0 - 使用帳號合併功能『連結成功』時回傳
export const gaSuccessBind = () => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '帳號合併',
    label: '連結成功',
  })
}

// 9.7.0 - 點擊帳號合併中『取消連結』按鈕時回傳
export const gaClickUnbind = () => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '帳號合併',
    label: '取消連結',
  })
}

// 9.5.0 - 點擊『如要取消訂閱請按這裡』時回傳
export const clickCancelOrder = () => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '訂單管理',
    label: '如要取消訂閱請按這裡',
  })
}

// 9.5.0 - 點擊『你確定要取消訂閱？』提示框的『取消訂閱』時回傳
export const execCancelOrder = () => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '訂單管理',
    label: '取消訂閱',
  })
}

// 9.5.0 - 點擊『你已經取消訂閱囉』提示框的『去給建議』時回傳
export const clickFeedback = () => {
  ReactGA.event({
    category: '01. 會員功能',
    action: '訂單管理',
    label: '去給建議',
  })
}

export const gaBannerImpress = (bannerName) => {
  ReactGA.event({
    category: '01. 推薦效果',
    action: 'Banner_impression',
    label: bannerName,
  })
}

export const gaBannerClick = (bannerName) => {
  ReactGA.event({
    category: '01. 推薦效果',
    action: 'Banner_click',
    label: bannerName,
  })
}

export const albumClick = (albumName, title) => {
  ReactGA.event({
    category: '01. 推薦效果',
    action: `${albumName}_click`,
    label: title,
  })
}
